import { makeStyles, type PositioningProps } from "@fluentui/react-components";

/**
 * Where a source picker's list opens: under the field, or above it when there is no room below.
 * Left to Fluent's defaults, a list too tall for either side was moved beside the field, off the
 * left edge of the page (SharePoint site search, Latest 2026-10-18).
 */
export const tagPickerListPositioning: PositioningProps = {
  position: "below",
  align: "start",
  fallbackPositions: ["above-start"],
};

/**
 * Layout for a TagPickerOption that shows secondary content (a URL, a logical name) under its
 * name.
 *
 * Fluent lays such an option out as `auto 1fr` columns, for a media slot in the first. The
 * source pickers have no media, so the name took that narrow column and the secondary content
 * the second: long names wrapped a word per line and secondary text started right of the name.
 * One column puts the secondary content under the name.
 */
export const useTagPickerOptionLayoutStyles = makeStyles({
  option: {
    gridTemplateColumns: "minmax(0, 1fr)",
  },
  // A URL has no spaces to wrap at, so without this it widens the list sideways.
  secondaryContent: {
    gridColumnStart: 1,
    overflowWrap: "anywhere",
  },
});
